export const bankDetailSelector = state => state.bankDetail;

